module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "flowchart-object jsplumb-draggable jsplumb-droppable",
    style: ({
      left: _vm.obj.view.left + "px",
      top: _vm.obj.view.top + "px",
      width: _vm.obj.view.w + "px",
      height: _vm.obj.view.h + "px"
    }),
    attrs: {
      "id": _vm.obj.view.id
    }
  }, [_c('div', {
    staticClass: "http_request_shell"
  }, [_c('div', {
    staticClass: "title control"
  }, [_c('div', {
    staticClass: "httpRequestTitle"
  }, [_vm._v(_vm._s(_vm.$t('scenarios.konstruktor.canvas.add.sendHttpRequest')))]), _vm._v(" "), _c('button', {
    staticClass: "delete",
    attrs: {
      "aria-label": _vm.$t('common.actions.delete')
    },
    on: {
      "click": function($event) {
        return _vm.deleteNode()
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "6px"
    }
  }, [_c('div', {
    staticClass: "is-overlay overlay-for-not-admin"
  }), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "field has-addons has-addons-centered"
  }, [_c('p', {
    staticClass: "control"
  }, [_c('span', {
    staticClass: "select"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.obj.data.method),
      expression: "obj.data.method"
    }],
    staticClass: "method",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.obj.data, "method", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "GET"
    }
  }, [_vm._v("GET")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "POST"
    }
  }, [_vm._v("POST")])])])]), _vm._v(" "), _c('p', {
    staticClass: "control"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.obj.data.url),
      expression: "obj.data.url"
    }],
    staticClass: "input url",
    attrs: {
      "type": "url",
      "placeholder": "url"
    },
    domProps: {
      "value": (_vm.obj.data.url)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.obj.data, "url", $event.target.value)
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "paramsHeadersBody"
  }, [_c('table', [_c('thead', [_c('th', {
    attrs: {
      "align": "center"
    }
  }, [_vm._v(_vm._s(_vm.$t('scenarios.konstruktor.canvas.answer.httpRequest.params')))]), _vm._v(" "), _c('th', {
    attrs: {
      "align": "center"
    }
  }, [_vm._v(_vm._s(_vm.$t('scenarios.konstruktor.canvas.answer.httpRequest.headers')))]), _vm._v(" "), _c('th', {
    attrs: {
      "align": "center"
    }
  }, [_vm._v(_vm._s(_vm.$t('scenarios.konstruktor.canvas.answer.httpRequest.body')))])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_c('div', {
    staticClass: "paramsList"
  }, [_c('table', [_c('tbody', _vm._l((_vm.paramsAsList), function(param, index) {
    return _c('tr', {
      staticClass: "param"
    }, [_c('td', {
      staticClass: "control"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (param.key),
        expression: "param.key"
      }],
      staticClass: "input key",
      attrs: {
        "type": "text",
        "placeholder": _vm.$t('common.key')
      },
      domProps: {
        "value": (param.key)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(param, "key", $event.target.value)
        }
      }
    })]), _vm._v(" "), _c('td', {
      staticClass: "control"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (param.value),
        expression: "param.value"
      }],
      staticClass: "input value",
      attrs: {
        "type": "text",
        "placeholder": _vm.$t('common.value')
      },
      domProps: {
        "value": (param.value)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(param, "value", $event.target.value)
        }
      }
    })])])
  }), 0)])])]), _vm._v(" "), _c('td', [_c('div', {
    staticClass: "headersList"
  }, [_c('table', [_c('tbody', _vm._l((_vm.headersAsList), function(header, index) {
    return _c('tr', {
      staticClass: "header"
    }, [_c('td', {
      staticClass: "control"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (header.key),
        expression: "header.key"
      }],
      staticClass: "input key",
      attrs: {
        "type": "text",
        "placeholder": _vm.$t('common.key')
      },
      domProps: {
        "value": (header.key)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(header, "key", $event.target.value)
        }
      }
    })]), _vm._v(" "), _c('td', {
      staticClass: "control"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (header.value),
        expression: "header.value"
      }],
      staticClass: "input value",
      attrs: {
        "type": "text",
        "placeholder": _vm.$t('common.value')
      },
      domProps: {
        "value": (header.value)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(header, "value", $event.target.value)
        }
      }
    })])])
  }), 0)])])]), _vm._v(" "), _c('td', [_c('div', {
    staticClass: "bodyTd"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.obj.data.body),
      expression: "obj.data.body"
    }],
    staticClass: "textarea body",
    attrs: {
      "placeholder": "json",
      "title": "json"
    },
    domProps: {
      "value": (_vm.obj.data.body)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.obj.data, "body", $event.target.value)
      }
    }
  })])])])])])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7a111e08"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./client/views/scenarios/konstruktor/HttpRequest.vue
// module id = 642
// module chunks = 42